import { render, staticRenderFns } from "./investMechanDialog.vue?vue&type=template&id=471d881e&scoped=true&"
import script from "./investMechanDialog.vue?vue&type=script&lang=js&"
export * from "./investMechanDialog.vue?vue&type=script&lang=js&"
import style0 from "./investMechanDialog.vue?vue&type=style&index=0&id=471d881e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471d881e",
  null
  
)

export default component.exports